import { LayoutRoute, Route } from "@soft-db/typed-router";

const dashboardRoutes = new LayoutRoute({
	name: "dashboard",
	path: "dashboard",
	component: () => import("@/pages/dashboard.vue"),
	meta: {
		feature: "dashboard",
	},
	children: [
		new Route({
			path: "",
			component: () => import("@/pages/dashboard/index.vue"),
		}),
		new Route({
			path: ":id",
			component: () => import("@/pages/dashboard/_id/index.vue"),
		}),
	],
});

export default dashboardRoutes;
